import { render } from "./LevgPos.vue?vue&type=template&id=28680ecb"
import script from "./LevgPos.vue?vue&type=script&lang=js"
export * from "./LevgPos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__